<template>
  <div>
    <a-time-unit-field
      :formLayout="formLayout"
      :size="size"
      :data="data"
      parentName="id_token_options"
      varName="id_token"
      varVerbose="ID Token"
    />
    <a-select-field
      :formLayout="formLayout"
      :size="size"
      varName="id_token_signed_response_alg"
      varLabel="Signing Algorithm"
      :varRequired="true"
      :varInitial="data.id_token_signed_response_alg"
      :disabled="true"
      type="schema"
      :varOptions="Algorithms"
    />
  </div>
</template>

<script>
import Algorithms from '@/configs/SigningAlgorithm.js';

export default {
  data() {
    return {
        Algorithms,
    };
  },
  props: {
    formLayout: String,
    size: String,
    data: Object,
    options: Object
  }
};
</script>
